import React from "react";
import { IonItem, IonLabel, IonList } from "@ionic/react";

const formatA = (count, hours, minutes) =>
  `${count}x ${hours}° ${minutes}'`;

const formatN = (count, hours, minutes) =>
  `${count}x ${hours}° ${minutes}'`;

/** Backend doplní prevDay* a prevClosedLogBookDay ze součtů položek deníku za předchozí plně uzavřený den s automatickým zápisem. */
const hasPrevGliderLogbook = (item) =>
  item.glider && item.prevClosedLogBookDay != null;

const gliderActiveOnClosedDay = (item) =>
  item.glider && ((item.count ?? 0) > 0 || (item.winchCount ?? 0) > 0);

export const PlaneBookDayItems = ({
  items,
  closed = false,
  currentDay,
}) => {
  const listItems = closed
    ? items.filter((it) => (!it.glider ? true : gliderActiveOnClosedDay(it)))
    : items;

  return (
    <IonList>
      {listItems.map((item, index) => (
        <IonItem key={`${item.identifier ?? "row"}-${index}`}>
          <IonLabel>
            <h2>{item.identifier}</h2>
            {item.glider ? (
              <>
                {closed && currentDay && (
                  <h3 className="plane-book-current-day">
                    {(item.count ?? 0) > 0 && (
                      <>
                        A: {formatA(item.count, item.hours, item.minutes)}
                      </>
                    )}
                    {(item.winchCount ?? 0) > 0 && (
                      <>
                        <br/>
                        N: {formatN(item.winchCount, item.winchHours, item.winchMinutes)}
                      </>
                    )}
                  </h3>
                )}
                {!closed && (
                  <>
                    {(item.count ?? 0) > 0 && (
                      <h3>A: {formatA(item.count, item.hours, item.minutes)}</h3>
                    )}
                    {(item.winchCount ?? 0) > 0 && (
                      <h3>N: {formatN(item.winchCount, item.winchHours, item.winchMinutes)}</h3>
                    )}
                  </>
                )}
              </>
            ) : (
              <h3>
                {item.count}x {item.hours}° {item.minutes}'
              </h3>
            )}
          </IonLabel>
          <div>
            {closed && (
                <span className="plane-book-prev-day">
                  {hasPrevGliderLogbook(item) && (
                      <>
                        {formatA(
                          item.prevDayCount,
                          item.prevDayHours ?? 0,
                          item.prevDayMinutes ?? 0
                      )} ({item.prevClosedLogBookDay})

                      </>
                  )}
                  {item.totalDayCount > 0 &&
                      <>
                        <br/>
                        {formatA(item.totalDayCount, item.totalDayHours, item.totalDayMinutes)} ({currentDay})
                      </>
                  }
                </span>
            )}
          </div>
        </IonItem>
      ))}
    </IonList>
  );
};
